import React from 'react';
import { makeStyles } from '@material-ui/core';
import { scissorStates, scissorTypes } from '../../Config/scissorStates'
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

export const ScissorStateComponent = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    let scissorStatus = "";
    if (props.scissorStatus) {
        scissorStatus = props.scissorStatus;
    }
    else {
        if (props.upper) {
            scissorStatus = props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER);
        }
        else {
            scissorStatus = props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER);
        }
    }

    let status = "";
    let upper = scissorStatus.scissorName === scissorTypes.UPPER;
    switch (scissorStatus.name) {
        case scissorStates.PRODUCTION:
            status = scissorStates.PRODUCTION.toUpperCase();
            break;
        case scissorStates.SCRAP:
            status = scissorStates.SCRAP.toUpperCase();
            break;
        case scissorStates.UNPLANNEDSTOP:
            status = scissorStates.UNPLANNEDSTOP.toUpperCase();

            break;
        case scissorStates.PLANNEDSTOP:
            status = scissorStates.PLANNEDSTOP.toUpperCase();

            break;
        default:
    }

    return (
        <div className={classes.container} style={{ borderRadius: props.size === "M" ? "5px" : (upper ? "5px 5px 0 0" : "0 0 5px 5px"), border: "1px solid #DEDEDE", borderBottom: upper && (props.size !== "M" && props.size !== "XS") ? "none" : "1px solid #DEDEDE" }}>
            {props.size !== "XS" &&
                <div className={classes.arrow}>
                    <div className={classes.lineNumber}>{props.machineNumber}</div>
                    <div className={classes.arrow}>
                        {upper ?
                            <img className={classes.arrowIcon} alt="scissorUp" src={process.env.PUBLIC_URL + '/img/scissorArrowUp.svg'} style={{ height: props.size === "M" ? "25px" : props.size === "S" ? "15px" : "0.8rem" }}></img>
                            :
                            <img className={classes.arrowIcon} alt="scissorDown" src={process.env.PUBLIC_URL + '/img/scissorArrowDown.svg'} style={{ height: props.size === "M" ? "25px" : props.size === "S" ? "15px" : "0.8rem" }}></img>}
                    </div>
                </div>
            }

            <div className={classes.status} style={{ backgroundColor: scissorStatus.backgroundColorInHex, color: scissorStatus.foregroundColorInHex, fontSize: props.size === "M" ? "20px" : props.size === "S" ? "10px" : "0.8rem", textWrap: "nowrap" }}>
                {t(status)}
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        justifyContent: "center",
    },
    status: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: "10px",
    },
    lineNumber: {
        float: "left",
        fontSize: "30px",
        fontFamily: "Lato, sans-serif",
        boxSizing: "border-box",
    },
    arrow: {
        width: "40%",
        float: "left",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    arrowIcon: {
        height: "20px",
    }
}));

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState
    }
}

export default connect(mapStateToProps)(ScissorStateComponent)